import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Globe2, Search } from 'lucide-react';
import ContentGrid from '../components/common/ContentGrid';
import { demoPosts, demoArticles, demoVideos } from '../data/demoData';
import { useShare } from '../hooks/useShare';

const regions = [
  { continent: 'Europe', countries: ['United Kingdom', 'Germany', 'France'] },
  { continent: 'Asia', countries: ['India', 'China', 'Japan'] },
  { continent: 'Africa', countries: ['Nigeria', 'Kenya', 'South Africa'] },
  { continent: 'Americas', countries: ['United States', 'Canada', 'Brazil'] }
];

export default function RegionalPage() {
  const { theme } = useTheme();
  const handleShare = useShare();
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedCountry, setSelectedCountry] = useState('');

  // Combine all content
  const allContent = [...demoPosts, ...demoArticles, ...demoVideos];

  // Filter content by region
  const filteredContent = allContent.filter(content => {
    if (!selectedRegion && !selectedCountry) return true;
    if (selectedRegion && !selectedCountry) {
      return content.region.continent === selectedRegion;
    }
    return content.region.continent === selectedRegion && 
           content.region.country === selectedCountry;
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Globe2 className="h-8 w-8 text-blue-500" />
          <h1 className={`text-2xl font-bold ${
            theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
          }`}>
            Regional Content
          </h1>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-4">
        <select
          value={selectedRegion}
          onChange={(e) => {
            setSelectedRegion(e.target.value);
            setSelectedCountry('');
          }}
          className={`
            px-4 py-2 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:outline-none
            ${theme === 'dark'
              ? 'bg-gray-800 border-gray-700 text-gray-100'
              : 'bg-white border-gray-200 text-gray-900'
            }
          `}
        >
          <option value="">All Regions</option>
          {regions.map(region => (
            <option key={region.continent} value={region.continent}>
              {region.continent}
            </option>
          ))}
        </select>

        {selectedRegion && (
          <select
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
            className={`
              px-4 py-2 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:outline-none
              ${theme === 'dark'
                ? 'bg-gray-800 border-gray-700 text-gray-100'
                : 'bg-white border-gray-200 text-gray-900'
              }
            `}
          >
            <option value="">All Countries</option>
            {regions.find(r => r.continent === selectedRegion)?.countries.map(country => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        )}
      </div>

      <ContentGrid
        items={filteredContent}
        onLike={(id) => {
          console.log('Liked content:', id);
        }}
        onShare={async (id) => {
          const content = filteredContent.find(item => item.id === id);
          if (content) {
            await handleShare(content);
          }
        }}
      />
    </div>
  );
}